export default __webpack_public_path__ + "static/media/480_dummy2016-grafikdesigner01-mobile-de.33398f44.png";